import React, { useCallback } from "react";
import { Button } from "../button";
import { Sheet } from "lucide-react";
import { writeFileXLSX, utils } from "xlsx";

type ExportExcelProps = {
  data: any[];
  filename?: string;
};

export const ExportExcel: React.FC<ExportExcelProps> = ({ data, filename }) => {
  const exportFile = useCallback(() => {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Data");
    writeFileXLSX(
      wb,
      filename ? `${filename}.xlsx` : `Export-${new Date().getTime()}.xlsx`
    );
  }, [data, filename]);
  return (
    <Button
      variant="outline"
      size="sm"
      className="w-full max-w-full md:max-w-max h-8 font-GilroySemibold lg:flex bg-green-600 text-white hover:bg-green-500 hover:text-white duration-300"
      onClick={exportFile}
    >
      <Sheet className="mr-2 h-4 w-4" />
      Exportar
    </Button>
  );
};
